export default (url) => {
  if (url) {
    return decodeURI(encodeURI(url).replace(/%C2%A0/g, '%20'))
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/filters/UrlEncode.js